import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import { useInterval } from "~/utils/use-interval";

export const StaggeredAnimations = () => {
  const [isVisible, setIsVisible] = useState(true);
  useInterval(() => {
    window.requestAnimationFrame(() => {
      setIsVisible((prev) => !prev);
    });
  }, 2000);
  return (
    <div className="flex w-full flex-col items-center justify-start gap-4">
      <motion.div
        animate={isVisible ? "visible" : "hidden"}
        className="w-full max-w-[300px] space-y-3"
        variants={{
          hidden: {
            transition: { staggerChildren: 0.2, staggerDirection: -1 },
          },
          visible: {
            transition: { staggerChildren: 0.2 },
          },
        }}
      >
        <motion.div
          className="h-8 w-full rounded-full bg-[rgba(255,255,255,.1)]"
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        />
        <motion.div
          className="h-8 w-full rounded-full bg-[rgba(255,255,255,.1)]"
          variants={{
            hidden: { opacity: 0, x: -20 },
            visible: { opacity: 1, x: 0 },
          }}
        />
        <motion.div
          className="h-8 w-full rounded-full bg-[rgba(255,255,255,.1)]"
          variants={{
            hidden: { opacity: 0, x: -20 },
            visible: { opacity: 1, x: 0 },
          }}
        />
        <motion.div
          className="h-8 w-full rounded-full bg-[rgba(255,255,255,.1)]"
          variants={{
            hidden: { opacity: 0, x: -20 },
            visible: { opacity: 1, x: 0 },
          }}
        />
      </motion.div>
    </div>
  );
};
